import React, { useState, useRef, useEffect } from 'react';
import { X } from 'lucide-react';
import { mockData } from '../mock';

const GalleryCard = ({ image, onSelect }) => {
  const cardRef = useRef(null);

  useEffect(() => {
    const el = cardRef.current;
    const handleMove = (e) => {
      const { left, top, width, height } = el.getBoundingClientRect();
      const x = (e.clientX - left) / width - 0.5;
      const y = (e.clientY - top) / height - 0.5;
      // Aplica inclinação 3D e zoom
      el.style.transform = `perspective(1000px) rotateY(${x * 12}deg) rotateX(${y * -12}deg) scale3d(1.02, 1.02, 1.02)`;
    };

    const handleLeave = () => {
      el.style.transform = `perspective(1000px) rotateY(0deg) rotateX(0deg) scale3d(1, 1, 1)`;
    };

    el.addEventListener('mousemove', handleMove);
    el.addEventListener('mouseleave', handleLeave);
    return () => {
      el.removeEventListener('mousemove', handleMove);
      el.removeEventListener('mouseleave', handleLeave);
    };
  }, []);

  return (
    <div
      ref={cardRef}
      onClick={() => onSelect(image)}
      className="relative group cursor-pointer rounded-[2rem] overflow-hidden shadow-xl bg-gray-200 aspect-[4/3] transition-all duration-500 ease-out transform-gpu"
      style={{ transformStyle: 'preserve-3d' }}
    >
      <img 
        src={image.url} 
        alt={image.alt}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" 
      />
      
      {/* Overlay com Gradiente Premium */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-8">
        <div style={{ transform: 'translateZ(40px)' }}>
          <p className="text-orange-500 font-black text-xs uppercase tracking-[0.3em] mb-2">Momento</p>
          <span className="text-white font-black text-2xl uppercase tracking-tighter block">{image.alt}</span>
        </div>
      </div>
      
      {/* Borda de brilho interna */}
      <div className="absolute inset-0 border border-white/10 rounded-[2rem] pointer-events-none" />
    </div>
  );
};

const Gallery = () => {
  const { gallery } = mockData;
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="galeria" className="py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Header Estilizado */}
        <div className="text-center mb-24">
          <h2 className="text-6xl md:text-7xl font-black text-gray-900 tracking-tighter mb-6 uppercase leading-none">
            {gallery.title.split(' ')[0]} <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-rose-600">{gallery.title.split(' ')[1]}</span>
          </h2>
          <p className="text-gray-500 text-lg md:text-xl font-bold max-w-2xl mx-auto uppercase tracking-wide">
            {gallery.subtitle}
          </p>
        </div>

        {/* Grid com espaçamento moderno */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {gallery.images.map((image) => (
            <GalleryCard key={image.id} image={image} onSelect={setSelectedImage} />
          ))}
        </div>

        {/* Modal / Lightbox (Mantive sua lógica funcional) */}
        {selectedImage && (
          <div
            className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center p-4 backdrop-blur-sm"
            onClick={() => setSelectedImage(null)}
          >
            <button className="absolute top-8 right-8 text-white hover:text-orange-500 transition-all transform hover:rotate-90">
              <X size={48} />
            </button>
            
            <div className="max-w-6xl w-full" onClick={e => e.stopPropagation()}>
              <img 
                src={selectedImage.url} 
                alt={selectedImage.alt}
                className="w-full h-auto max-h-[80vh] object-contain rounded-2xl shadow-[0_0_50px_rgba(255,100,0,0.2)]"
              />
              <p className="text-white text-center mt-8 text-3xl font-black uppercase tracking-tighter">{selectedImage.alt}</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;